module.exports = __webpack_public_path__ + "img/not-common-icon.c12314de.png";